import { User } from '@graphics/gfx-common/dist/types'

export interface ICreated {
  created: string
  createdBy: User
}

export interface IMaybeModified {
  modified?: string
  modifiedBy?: User
}

export type UserDateType = ICreated & IMaybeModified

export enum DateRanges {
  any = 'any',
  on = 'on',
  between = 'between',
}

export interface IPublishedDateRange {
  publishedFrom?: string
  publishedTo?: string
}

export interface IDateRange extends IPublishedDateRange {
  dateFrom?: string
  dateTo?: string
}

export enum DateRangeQueryParamsOptions {
  dateFrom = 'dateFrom',
  dateTo = 'dateTo',
  publishedFrom = 'publishedFrom',
  publishedTo = 'publishedTo',
}
